import { useEffect } from 'react';
import { useSWRConfig } from 'swr';
import { getAppSocket, retainAppSocket } from '../../services/socketService';

const isSyncLogsKey = (key: unknown): key is string =>
  typeof key === 'string' && key.startsWith('/emails') && key.includes('sync-logs');

/** Socket-driven revalidation for sync-log SWR keys when live mode is enabled. */
export function useSyncLogsLiveRefresh(enabled: boolean): void {
  const { mutate } = useSWRConfig();

  useEffect(() => {
    if (!enabled) return;

    const release = retainAppSocket();
    if (!release) return;

    const socket = getAppSocket();
    if (!socket) {
      release();
      return;
    }

    const revalidate = () => {
      void mutate((key) => isSyncLogsKey(key), undefined, { revalidate: true });
    };

    socket.on('sync-logs:invalidate', revalidate);
    socket.on('emails:invalidate', revalidate);

    return () => {
      socket.off('sync-logs:invalidate', revalidate);
      socket.off('emails:invalidate', revalidate);
      release();
    };
  }, [enabled, mutate]);
}
